import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSavedItemCount } from '@/redux/modules/savedItemCount';
import { GlobalState } from '@/redux/rootReducer';
import isEqual from 'react-fast-compare';
import { isUserLoggedIn } from '@/redux/modules/user';
import ItemSaveButton from './ItemSaveButton';
import ItemSaveIcon from './ItemSaveIcon';
import { ModalContext } from '@/redux/modules/modal';
import ShouldLogInContainer from '@/components/ShouldLogIn/ShouldLogInContainer';
import { toggleItemSave } from '@/redux/modules/saveItem';

type Props = {
    button?: boolean;
    buttonClassName?: string;
    className?: string;
    iconClassName?: string;
    itemId: number;
    showSavedCount?: boolean;
};

const ItemSaveContainer = (props: Props) => {
    const { button, buttonClassName, className, iconClassName, itemId, showSavedCount } = props;

    const dispatch = useDispatch();
    const { savedCount } = useSelector((state: GlobalState) => getSavedItemCount(state, itemId), isEqual);
    const userLoggedIn = useSelector(isUserLoggedIn);

    const modalContext: ModalContext = { id: itemId, type: 'save item' };

    const onToggleSave = React.useCallback(() => {
        dispatch(toggleItemSave(itemId));
    }, [dispatch, itemId]);

    return (
        <>
            {button ? (
                <ItemSaveButton className={buttonClassName} savedCount={savedCount} showSavedCount={showSavedCount} />
            ) : (
                <ShouldLogInContainer
                    forceSignUp={!userLoggedIn}
                    modalContext={modalContext}
                    runFunction={onToggleSave}
                >
                    <div className={className}>
                        <ItemSaveIcon className={iconClassName} itemId={itemId} />
                    </div>
                </ShouldLogInContainer>
            )}
        </>
    );
};

export default React.memo<Props>(ItemSaveContainer);
